import { render, staticRenderFns } from "./configuration-input.vue?vue&type=template&id=624cc019&scoped=true"
import script from "./configuration-input.vue?vue&type=script&lang=js"
export * from "./configuration-input.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "624cc019",
  null
  
)

export default component.exports